import React, { Component } from "react"
import scroll from "react-scroll"
import Button from "@atlaskit/button"
import DynamicTable from "@atlaskit/dynamic-table"
import Moment from "moment-timezone"
import "moment-duration-format"

import WarningIcon from "@atlaskit/icon/glyph/warning"
import CheckIcon from "@atlaskit/icon/glyph/check"
import ErrorList from "./ErrorList"

const check_icon = <CheckIcon label="Check icon" secondaryColor="inherit" />
const warning_icon = (
  <WarningIcon label="Warning icon" secondaryColor="inherit" />
)

var header = {
  cells: [
    {
      key: "0",
      className: "columnHeader",
      content: "Datum"
    },
    {
      key: "1",
      className: "columnHeader",
      content: "Arbeitszeit"
    },
    {
      key: "2",
      className: "columnHeader",
      content: "Gleitzeit"
    },
    {
      key: "3",
      className: "columnHeader",
      content: "Fehler"
    }
  ]
}

export default class ValidationList extends Component {
  render() {
    console.log("render ValidationList")
    const {
      validation_errors,
      expanded_days,
      work_time_duration,
      current_extra_time_duration,
      // total_extra_time_duration,
      is_loading,
      handleErrorClick
    } = this.props

    var error_sum = 0
    if (validation_errors.days) {
      validation_errors.days.forEach(function(day) {
        error_sum += day.errors.length
      })
      if (error_sum === 0) {
        header.cells[0].width = 10
        header.cells[1].width = 10
        header.cells[2].width = 10
        header.cells[3].width = 10
      } else {
        header.cells[0].width = 4
        header.cells[1].width = 5
        header.cells[2].width = 5
        header.cells[3].width = 26
      }
    } else {
      header.cells[0].width = 10
      header.cells[1].width = 10
      header.cells[2].width = 10
      header.cells[3].width = 10
    }

    var rows = []
    if (validation_errors.days) {
      validation_errors.days.forEach(function(day) {
        var row = {}
        row.key = day.date
        row.cells = []

        var day_moment = new Moment(day.date)
        var content_date = day_moment.format("DD.MM.YYYY")

        var content_worktime = Moment.duration(day.workTime, "seconds").format(
          "h[h ]m[m]"
        )

        var content_extratime
        if (
          Moment.duration(day.extraTime, "seconds")
            .format("h[h ]m[m]")
            .includes("-") ||
          Moment.duration(day.extraTime, "seconds").asMinutes() === 0
        ) {
          content_extratime = Moment.duration(day.extraTime, "seconds").format(
            "h[h ]m[m]"
          )
        } else {
          content_extratime = Moment.duration(day.extraTime, "seconds").format(
            "[+]h[h ]m[m]"
          )
        }

        row.cells.push({
          style: { fontSize: "smaller" },
          content: content_date
        })

        if (day.description) {
          row.cells.push({
            style: { fontSize: "smaller" },
            content: <b>{day.description}</b>
          })

          row.cells.push({})
        } else {
          row.cells.push({
            style: { fontSize: "smaller" },
            content: content_worktime
          })

          row.cells.push({
            style: { fontSize: "smaller" },
            content: content_extratime
          })
        }

        row.cells.push({
          content: (
            <React.Fragment>
              <scroll.Element name={Moment(day.date).format("YYYY-MM-DD")} />
              <Button
                key={day.date}
                iconBefore={day.errors.length === 0 ? check_icon : warning_icon}
                className={
                  day.errors.length === 0 ? "buttonDisabled" : "buttonStandard"
                }
                appearance={day.errors.length === 0 ? "secondary" : "primary"}
                onClick={
                  day.errors.length !== 0 && (() => handleErrorClick(day.date))
                }
              >
                {day.errors.length === 0 ? "OK" : day.errors.length + " Fehler"}
              </Button>
            </React.Fragment>
          )
        })

        rows.push(row)

        if (
          day.errors.length === 0 &&
          expanded_days !== null &&
          expanded_days.get(day.date) === true
        ) {
          // close errors if they do not exist anymore after refresh
          handleErrorClick(day.date)
        } else if (
          expanded_days !== null &&
          expanded_days.get(day.date) === true
        ) {
          var error_list = {
            content: <ErrorList errors={day.errors} />
          }
          var error_list_row = {}
          error_list_row.key = day.date + day.errors.length
          error_list_row.cells = []
          error_list_row.cells.push({
            content: content_date + "1",
            style: { fontSize: "0" }
          })
          error_list_row.cells.push({
            content: content_worktime + "1",
            style: { fontSize: "0" }
          })
          error_list_row.cells.push({
            content: content_extratime + "1",
            style: { fontSize: "0" }
          })

          error_list_row.cells.push(error_list)
          rows.push(error_list_row)
        }
      })
    }

    if (rows.length !== 0) {
      var row = {}
      row.key = "sum"
      row.cells = []
      row.cells.push({
        style: {},
        content: <p>Summe</p>
      })

      row.cells.push({
        style: {},
        content: <p>{work_time_duration.format("h[h ]m[m]")}</p>
      })

      if (current_extra_time_duration) {
        var color_extra_time = "green"
        if (current_extra_time_duration.format("h[h ]m[m]").includes("-")) {
          color_extra_time = "red"
        } else if (current_extra_time_duration.format("h[h ]m[m]") === "0m") {
          color_extra_time = "black"
        }

        row.cells.push({
          style: { color: color_extra_time },
          content: (
            <p>
              {current_extra_time_duration.format("h[h ]m[m]").includes("-") ||
              current_extra_time_duration.asMinutes() === 0
                ? current_extra_time_duration.format("h[h ]m[m]")
                : current_extra_time_duration.format("[+]h[h ]m[m]")}
            </p>
          )
        })
      } else {
        row.cells.push({
          style: {},
          content: <p>-</p>
        })
      }
      row.cells.push({})

      rows.push(row)

      // row = {}
      // row.key = "total_sum"
      // row.cells = []

      // row.cells.push({
      //   style: {},
      //   content: <b>Aktuelle Gleitzeit</b>
      // })

      // row.cells.push({})

      // if (total_extra_time_duration) {
      //   var color_total_extra_time = "green"
      //   if (total_extra_time_duration.format("h[h ]m[m]").includes("-")) {
      //     color_total_extra_time = "red"
      //   } else if (total_extra_time_duration.format("h[h ]m[m]") === "0m") {
      //     color_total_extra_time = "black"
      //   }

      //   row.cells.push({
      //     style: { color: color_total_extra_time },
      //     content: (
      //       <b>
      //         {total_extra_time_duration.format("h[h ]m[m]").includes("-") ||
      //         total_extra_time_duration.asMinutes() === 0
      //           ? total_extra_time_duration.format("h[h ]m[m]")
      //           : total_extra_time_duration.format("[+]h[h ]m[m]")}
      //       </b>
      //     )
      //   })
      // } else {
      //   row.cells.push({
      //     style: {},
      //     content: <b>-</b>
      //   })
      // }
      // row.cells.push({})
      // rows.push(row)
    }

    return (
      <div style={{ marginTop: "40px" }}>
        <DynamicTable
          caption=""
          head={header}
          rows={rows}
          loadingSpinnerSize="large"
          isLoading={is_loading}
          isFixedSize
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ValidationList.jsx